// extracted by mini-css-extract-plugin
export default {"spinnerBlock":"i8QjvvhQil"};